import { useMutation } from 'react-relay';
import { graphql } from 'react-relay';
import { useTrustpilotReviewMutation } from './__generated__/useTrustpilotReviewMutation.graphql';

const trustpilotReviewMutation = graphql`
  mutation useTrustpilotReviewMutation {
    userConsentedToFeedback
  }
`;

export default function useTrustpilotReview() {
  const [userConsentedToFeedback] =
    useMutation<useTrustpilotReviewMutation>(trustpilotReviewMutation);
  const handleTriggerUserConsentedToFeedback = () => {
    userConsentedToFeedback({ variables: {} });
  };

  return handleTriggerUserConsentedToFeedback;
}
